module.exports = __webpack_public_path__ + "static/media/facebook.46612180.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/galery/originals/facebook.svg
// module id = 117
// module chunks = 0